import {
    PRODUCTS_INSIGHTS_REPORT_GET_START,
    PRODUCTS_INSIGHTS_REPORT_GET_SUCCESS,
    PRODUCTS_INSIGHTS_REPORT_GET_ERROR,
    ProductsInsightsReportAction
} from 'actions/insights/sales/productsInsightsReport/ProductsInsightsReportActionsTypes';

import { initialProductsInsightsReportState, ProductsInsightsReportState } from './ProductsInsightsReportState';

export const productsInsightsReportReducer = (
    state: ProductsInsightsReportState = initialProductsInsightsReportState,
    action: ProductsInsightsReportAction
): ProductsInsightsReportState => {
    switch (action.type) {
        case PRODUCTS_INSIGHTS_REPORT_GET_START:
            return { ...state, loading: true };

        case PRODUCTS_INSIGHTS_REPORT_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                report: action.payload.report
            };

        case PRODUCTS_INSIGHTS_REPORT_GET_ERROR:
            return { ...state, loading: false };

        default:
            return state;
    }
};

export default productsInsightsReportReducer;
